import { cubeCustomColors } from "../../../../tailwind.config";

export const defaultColDefAnalytics = {
  enableCellChangeFlash: false,
  suppressHeaderMenuButton: true,
  filter: false,
  cellStyle: { borderRight: "Var(--ag-grid-cubeCustom-cell-border)" },
  flex: 1,
};

export function genericAnalyticsTables(theme: string | undefined) {
  if (theme == "light") {
    return {
      "--ag-background-color": cubeCustomColors.cubeTableRowColour[750],
      "--ag-odd-row-background-color": cubeCustomColors.cubeTableRowColour[750],
      "--ag-row-hover-color": cubeCustomColors.cubeTableRowColour[600], // Hover color
    };
  } else {
    return {
      "--ag-background-color": "transparent",
      "--ag-odd-row-background-color": "transparent",
      "--ag-row-hover-color": cubeCustomColors.cubeTableRowColour[800], // Hover color
    };
  }
}
